import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyShift = ({
  height = 16,
  width = 34,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 34 16" {...props}>
    <path
      d="M2.77151 16C1.85983 16 1.16999 15.772 0.701994 15.3159C0.233998 14.8597 0 14.1756 0 13.2634V2.74572C0 1.83352 0.233998 1.14937 0.701994 0.693273C1.16999 0.231091 1.85983 0 2.77151 0H31.2285C32.1462 0 32.8361 0.231091 33.298 0.693273C33.766 1.15545 34 1.8396 34 2.74572V13.2634C34 14.1695 33.766 14.8506 33.298 15.3067C32.8361 15.7689 32.1462 16 31.2285 16H2.77151ZM2.83533 14.4584H31.1647C31.5719 14.4584 31.8879 14.3489 32.1128 14.13C32.3377 13.9111 32.4501 13.5857 32.4501 13.1539V2.85519C32.4501 2.42341 32.3377 2.09806 32.1128 1.87913C31.8879 1.66021 31.5719 1.55074 31.1647 1.55074H2.83533C2.42203 1.55074 2.10598 1.66021 1.88718 1.87913C1.66838 2.09806 1.55897 2.42341 1.55897 2.85519V13.1539C1.55897 13.5857 1.66838 13.9111 1.88718 14.13C2.10598 14.3489 2.42203 14.4584 2.83533 14.4584Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M7.52695 12.3961C5.76295 12.3961 4.57495 11.2681 4.57495 9.8641H6.02695C6.03895 10.5121 6.65095 11.1001 7.56295 11.1001C8.40295 11.1001 8.94295 10.5841 8.94295 9.9361C8.94295 9.3601 8.45095 9.0241 7.75495 8.8321L6.72295 8.5441C4.94695 8.0881 4.63495 7.0201 4.63495 6.3001C4.63495 4.8361 5.91895 3.8401 7.44295 3.8401C8.95495 3.8401 10.143 4.7761 10.143 6.3241H8.69095C8.69095 5.6401 8.17495 5.1481 7.40695 5.1481C6.69895 5.1481 6.11095 5.6281 6.11095 6.2761C6.11095 6.5041 6.18295 6.9841 7.13095 7.2361L8.11495 7.5241C9.41095 7.8841 10.407 8.5561 10.407 9.8761C10.407 11.3881 9.14695 12.3961 7.52695 12.3961Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.9613 6.5041C16.4013 6.5041 17.2053 7.4761 17.2053 9.1081V12.2521H15.8133V9.2041C15.8133 8.3041 15.2733 7.8241 14.6493 7.8241C14.0133 7.8241 13.2213 8.1961 13.2213 9.2881V12.2521H11.8293V3.6001H13.2213V7.5001C13.4973 6.8161 14.3973 6.5041 14.9613 6.5041Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M19.5862 5.5201C19.0942 5.5201 18.6742 5.1481 18.6742 4.6681C18.6742 4.1761 19.0942 3.8161 19.5862 3.8161C20.0902 3.8161 20.4862 4.1761 20.4862 4.6681C20.4862 5.1481 20.0902 5.5201 19.5862 5.5201ZM18.8902 12.2521V6.6481H20.2822V12.2521H18.8902Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M25.1691 4.8961C24.2211 4.8961 23.9451 5.4241 23.9571 6.1081V6.6481H25.2051V7.7521H23.9571V12.2521H22.5651V7.7521H21.4971V6.6481H22.5651V6.1801C22.5651 4.5721 23.3331 3.6001 24.8931 3.6001H25.5531V4.8961H25.1691Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M29.4281 6.6481V7.7521H28.2401V12.2521H26.8481V7.7521H25.8401V6.6481H26.8481V4.5841H28.2401V6.6481H29.4281Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
